exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".language-switch {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  padding: 4px 10px;\n  position: absolute;\n  z-index: 2;\n  right: 20px;\n  top: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  background: none; }\n  .language-switch option {\n    color: #333; }\n\n.inner-nav-lang .language-switch {\n  top: 24px; }\n\n.footer-lang .language-switch {\n  display: inline-block;\n  position: static;\n  color: rgba(255, 255, 255, 0.4);\n  border-color: rgba(255, 255, 255, 0.4);\n  padding: 2px 6px;\n  margin: 0 6px; }\n\n.footer-lang.small .language-switch {\n  color: #999;\n  border-color: #999; }\n\n@media only screen and (max-width: 1400px) {\n  .language-switch {\n    display: none; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/common/language/language.scss
// module id = 724
// module chunks = 3